import { ChangeDetectionStrategy, Component, computed, input } from '@angular/core';
import { NgOptimizedImage } from '@angular/common';
import { CountUpDirective } from '../../../../shared/directives/count-up.directive';
import { PublicStatsBannerData } from '../../data/home-blocks.model';
import {
  formatStatValue,
  resolveHomeBannerUrl,
} from '../../../../shared/utils/home-blocks.utils';

interface StatVm {
  // Texto formateado completo ("+ de 4 000" / "8 500") — útil cuando la card
  // muestra el string final sin animar.
  display: string;
  // Solo el dígito raw (sin prefijo) para el countUp; el prefijo se pinta aparte.
  value: number;
  label: string;
  approximate: boolean;
}

@Component({
  selector: 'app-stats-block',
  imports: [NgOptimizedImage, CountUpDirective],
  templateUrl: './stats-block.component.html',
  styleUrl: './stats-block.component.css',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class StatsBlockComponent {
  readonly data = input<PublicStatsBannerData | null>(null);

  protected readonly title = computed(() => this.data()?.title ?? '');
  protected readonly subtitle = computed(() => this.data()?.subtitle ?? '');
  protected readonly eyebrow = computed(() => this.data()?.eyebrow ?? '');
  protected readonly backgroundImage = computed(() =>
    resolveHomeBannerUrl(this.data()?.background_image),
  );
  protected readonly backgroundAlt = computed(
    () => this.data()?.background_image?.alt ?? this.title(),
  );

  // El backend garantiza exactamente 4 stats; este computed los proyecta al
  // view-model con el string ya formateado para no llamar funciones en el
  // template en cada CD.
  protected readonly stats = computed<StatVm[]>(() => {
    const value = this.data();
    if (!value) return [];
    return value.stats.map((s) => ({
      display: formatStatValue(s),
      value: s.number,
      label: s.label,
      approximate: s.is_approximate,
    }));
  });

  protected readonly shouldRender = computed(() => this.data() !== null);
}
